




import Class from './c-chart-bars-view';
export default Class;
